module.exports = __webpack_public_path__ + "media/effects-3.d84cb83b.webm";